// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r3eh","questions":"styles_questions__2iXvE","footer":"styles_footer__3i4sF"};